<template>
    <div class="quit_container">
        <div>
            <div class="quit_top">
                 <div>
                    <span>姓名：</span>
                    <span>{{users.userName}}</span>
                 </div>
                 <div>
                    <span>所属部门：</span>
                    <span>{{users.dept.deptName}}</span>
                 </div>
                 <div>
                    <span>部门负责人：</span>
                    <span>{{users.dept.leader}}</span>
                 </div>
            </div>
            <!-- <div class="return">
                <a-button type="primary" @click="returnUserManagement()">返回</a-button>
            </div> -->
            <!-- <a-button type="primary" @click="">完成</a-button> -->
        </div>
        <div class="quit_bottom">
             <a-button type="primary" @click="fistStep" :disabled="!status">第一步：责任物品</a-button>
             <!-- <div id="demo14"></div> -->
            <a-button type="primary" @click="secondStep" :disabled="status">第二步：保管物品</a-button>

      <div>
         <div v-if="type == 1">
               <DutyGoods :rowData="rowData" @fisterTab="getTab" :userName="users.userName"></DutyGoods>
         </div>
         <div v-else-if="type == 2" >
             <StorageGoods :userName="users.userName" @secondTab="getData"></StorageGoods>
         </div>
      </div>







      
        </div>
    </div>
</template>
<script>
// import { tree_all } from '@/api/Industry.js'
import DutyGoods from './dutyGoods/index.vue'
import StorageGoods from './storageGoods/index.vue'
import { usreInfo, user_details } from '@/api/Industry'
import { changUserStatus } from '@/api/system'

export default{
    components: {
        DutyGoods,
        StorageGoods
		},
         props:['rowData'],
    data() {
        return {
            users: [],
            goods: [],
            status: true,
            current: 1,
            type: 1,

        }
    },
    created() {

    },
    mounted() {
    console.log( this.$route.query.id, ' this.$route.query.id++++++++++++++++++++++++++')
    user_details(this.$route.query.id).then(res => {
        this.users = res
        console.log( this.users, 'res888888888===========================')

    })
        this.getTab(data)

    //获取当前人的数据
        // tree_all().then(res => {
        //     console.log(res, 'res================================');
        //     // if (res. == this.$store.state.user.info.companyId)
        //   })
    },
    
    watch: {
  

    },
    methods: {
        fistStep() {
             this.type = 1

        },
        secondStep() {
             this.type = 2

        },

               getData(data) {
             console.log(data, 'data66666============================')
             if (data.length < 1) {
                //   this.$router.push({
				// 	            path: '/system/UserList'
			    //                	})

             	changUserStatus({
                     userId: this.users.userId,
                     status: '1',
                 }).then((res) => {
                    if (res.code === 200) {
                        //  this.$emit('put')
                        this.$message.success('该用户名下已无责任物品与保管物品，修改状态成功！')
                            this.$router.push({
                        path: '/system/UserList'
                        })
                        
                    } else {
                        this.$message.error(res.msg)
                    }
                   
                })

            } 

        },
        getTab(data){
            if (data.length < 1) {
                this.status = false
                this.type = 2
            } else {
                //  this.type = 1
                // this.status = true

            }
            
        },
        // returnUserManagement() {
        //     this.$router.push({
		// 			path: '/system/UserList'
		// 		})

        // }
       
    }
}
</script>
<style>
/* #demo14 {
  border: 16px solid transparent;
  border-left: 20px solid #f00;
  display: inline-block;
  margin: 5px 15px;
  width: 0;
  height: 0px;
} */
.title {
    margin: 20px 0;
    font-size: 20px;
    font-weight: 700;
}
.quit_top {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    width: 500px;
    padding: 15px;

}
.return {
    position: absolute;
    top: 60px;
    right: 120px;
}

</style>
